import React from 'react';
import { QUERY_GET_MY_ORDER_IN_CLASSE } from '../../../graphql/query/commande/queryCommandesByUser';
import { ApolloError, useQuery } from '@apollo/client';
import { ErrorContainer } from '../Error/ErrorContainer';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { useRefetchData } from '../../../helpers/refetch/refetchData';
import CommandesTableView from './CommandeTable.view';
import {
  CSVCommandesType,
  CommandeDef
} from '../../../types/commande/commande.def';
import { ID } from '../../../types/typeDef';
import {
  formatCommandes,
  formatCsvCommandes
} from 'helpers/commande/formatCommandesTable';
import { QueryGetMyOrderInClasseQuery } from '../../../graphql/generated/graphql';

interface CommandesTableProps {
  userID: string;
  isExternalUser?: boolean;
  toCommandeSinglePage: (id: ID) => void;
  toCommandeUpdatePage: (id: ID) => void;
}

const CommandesTable = ({
  userID,
  isExternalUser = false,
  toCommandeSinglePage,
  toCommandeUpdatePage
}: CommandesTableProps): JSX.Element => {
  const { data, error, loading, refetch } = useQuery<
    QueryGetMyOrderInClasseQuery
  >(QUERY_GET_MY_ORDER_IN_CLASSE, {
    variables: { id: userID }
  });
  useRefetchData(refetch);

  if (loading) return <LoadingLayout />;
  if (error) {
    return (
      <ErrorContainer
        text={"Les commandes de l'utilisateur n'ont pas été trouvée"}
        detailErr={new ApolloError(error)}
      />
    );
  }

  const commandes: CommandeDef[] = formatCommandes(data);
  const csvCommandes: CSVCommandesType = formatCsvCommandes(data);
  const firstname = data?.getMyOrdersInClasse?.firstname;
  const lastname = data?.getMyOrdersInClasse?.lastname;

  return (
    <CommandesTableView
      ExternalUserName={isExternalUser && `${firstname} ${lastname}`}
      commandes={commandes}
      csvCommandes={csvCommandes}
      csvCommandesName={`${firstname}-${lastname}`.toUpperCase()}
      toCommandeSinglePage={toCommandeSinglePage}
      toCommandeUpdatePage={toCommandeUpdatePage}
    />
  );
};

export default CommandesTable;
